<template>
  <div class="modal fade" tabindex="-1"   role="dialog" aria-hidden="true" data-backdrop="static" :id="this.$attrs.id">
    <div class="modal-dialog modal-dialog-centered" :class="size ? 'modal-'+size : ''" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{title}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('resetField')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <slot name="modal-form">

        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseModal",
  props:{
    title:{
      type:String,
      default:"Base Modal"
    },
    size:{
      type:String,
      default:'',
    },
  },

  mounted() {
    $(document).on('show.bs.modal',`#${this.$attrs.id}`, function() {
      let zIndex = 1040 + (10 * $('.modal.show').length);
      $(this).css('z-index', zIndex);
      setTimeout(function() {
        $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
      }, 0);
    });
  },
}
</script>

<style scoped>

</style>
